import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { growthbook, initGrowthBook } from "./services/growthbook";
import { Sentry } from "./services/sentry";

import "./App.scss";
import Pages from "./pages";
import ServerError from "./components/ServerError";
import loaderAnimation from "./assets/loader.png";

const theme = createTheme({
  palette: {
    primary: {
      main: "rgb(101, 107, 116)",
    },
  },
  typography: {
    h4: {
      fontSize: "1.2rem",
      fontWeight: "bold",
      lineHeight: "3rem",
    },
  },
});

const App = () => {
  useEffect(() => {
    initGrowthBook();

    // Preload the loader animation so the Spinner shows instantly
    const img = new Image();
    img.src = loaderAnimation;
  }, []);

  return (
    <GrowthBookProvider growthbook={growthbook}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ThemeProvider theme={theme}>
          <SnackbarProvider maxSnack={3}>
            <BrowserRouter>
              <Sentry.ErrorBoundary fallback={<ServerError />}>
                <Pages />
              </Sentry.ErrorBoundary>
            </BrowserRouter>
          </SnackbarProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </GrowthBookProvider>
  );
};

export default App;
